<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-on="on" outlined color="red"> <v-icon>mdi mdi-archive-arrow-down-outline</v-icon> Trash </v-btn>
      </template>

      <v-card class="px-5 py-5">
        <v-card-title class="text-h5"> Recently Deleted </v-card-title>

        <v-data-table :headers="headers" :items="sections" :items-per-page="5" hide-default-footer>
          <template v-slot:item.children_count="{ item }">
            {{ item.children.length || 0 }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn icon color="green" @click="restore(item.id)">
              <v-icon>mdi-restore</v-icon>
            </v-btn>
            <v-btn icon color="red" @click="hardDelete(item.id)">
              <v-icon>mdi-delete-forever</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.updated_at="{ item }">
            {{ formatDateFull(item.updated_at) }}
          </template>

          <template v-slot:no-data>
            <v-card-text class="text-center"> No items in the trash. </v-card-text>
          </template>
        </v-data-table>

        <v-divider></v-divider>
        <v-card-actions class="mt-4">
          <v-spacer></v-spacer>
          <v-btn @click="emptyTrash" color="error"> Empty Trash </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import moment from 'moment-timezone';
export default Vue.extend({
  props: {
    sections: {
      type: Array,
      required: true,
    },
    restore: {
      type: Function,
      required: true,
    },
    hardDelete: {
      type: Function,
      required: true,
    },
    emptyTrash: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: 'Section ID',
          align: 'center',
          value: 'id',
          sortable: false,
        },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Children Count', value: 'children_count', align: 'center', sortable: false },
        { text: 'Deleted At', value: 'updated_at', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
      ],
    };
  },
  methods: {
    formatDateFull(date) {
      if (!date) return;
      const stillUtc = moment.tz(date, 'Asia/Bangkok');
      return stillUtc.format('DD/MM/YYYY HH:mm');
    },
  },
});
</script>
